import { render, staticRenderFns } from "./DepartmentManageView.vue?vue&type=template&id=ebed0d60&scoped=true&"
import script from "./DepartmentManageView.vue?vue&type=script&lang=js&"
export * from "./DepartmentManageView.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentManageView.vue?vue&type=style&index=0&id=ebed0d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebed0d60",
  null
  
)

export default component.exports